(function () {
	'use strict';

	try{if(typeof document != 'undefined'){var elementStyle = document.createElement('style');elementStyle.appendChild(document.createTextNode("._checkmark_1pvfm_1 {\n    cursor: pointer;\n    user-select: none;\n    border-radius: 4px;\n    border: 0.1rem solid var(--color-neutral70);\n}\n\n._checkmark_1pvfm_1:hover {\n    outline: 2px var(--axa-fr-border-select);\n    outline-style: auto;\n}\n\n._checked_1pvfm_13 {\n    box-shadow: 0 4px 16px -2px rgba(48, 50, 193, 0.2);\n    outline: 2px var(--axa-fr-border-select);\n    outline-style: auto;\n}\n._host_1624r_1 {\n    display: flex;\n    gap: 24px;\n}._host_1624r_1 {\n    display: flex;\n    gap: 24px;\n}"));document.head.appendChild(elementStyle);}}catch(e){console.error('vite-plugin-css-injected-by-js', e);}

})();
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { Children, cloneElement } from 'react';

const checkmark = "_checkmark_1pvfm_1";
const checked = "_checked_1pvfm_13";
const styles$2 = {
	checkmark: checkmark,
	checked: checked
};

const Selectable = (props) => {
  const { children, checkedClassName = styles$2.checked, className, value } = props;
  const handleOnClick = () => props.onChange?.(value);
  const handleOnKeyDown = (event) => {
    if (["Enter", "Space"].includes(event.code)) {
      handleOnClick();
    }
  };
  return /* @__PURE__ */ jsx(
    "div",
    {
      role: "radio",
      "aria-checked": props.checked,
      "data-value": props.value,
      "aria-labelledby": props.labelledby,
      tabIndex: 0,
      className: classNames(styles$2.checkmark, className, { [checkedClassName]: props.checked }),
      onClick: handleOnClick,
      onKeyDown: handleOnKeyDown,
      children
    }
  );
};

const host$1 = "_host_1624r_1";
const styles$1 = {
	host: host$1
};

const SelectableGroup = (props) => {
  const radios = Children?.map(
    props.children,
    (child) => cloneElement(child, {
      checked: props.value === child.props.value,
      checkedClassName: props.checkedClassName ?? child.props.checkedClassName,
      onChange: props.onChange
    })
  );
  return /* @__PURE__ */ jsx(
    "div",
    {
      role: "radiogroup",
      "aria-labelledby": props.labelledby,
      className: classNames(styles$1.host, props.className),
      children: radios
    }
  );
};

const host = "_host_1624r_1";
const styles = {
	host: host
};

const SelectableGroupMulti = (props) => {
  const isChecked = (itemValue) => {
    return props.value?.includes(itemValue);
  };
  const handleOnChange = (itemValue) => {
    const checked = isChecked(itemValue ?? "");
    const values = checked ? props.value?.filter((value) => value !== itemValue) : [...props.value ?? [], itemValue ?? ""];
    props.onChange?.(values);
  };
  const radios = Children?.map(
    props.children,
    (child) => cloneElement(child, {
      checked: isChecked(child.props.value ?? ""),
      checkedClassName: props.checkedClassName ?? child.props.checkedClassName,
      onChange: handleOnChange
    })
  );
  return /* @__PURE__ */ jsx(
    "div",
    {
      role: "radiogroup",
      "aria-labelledby": props.labelledby,
      className: classNames(styles.host, props.className),
      children: radios
    }
  );
};

export { Selectable, SelectableGroup, SelectableGroupMulti };
